import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../hooks/redux'
import styles from './ActivityBar.module.css'
import { IcBicycle } from './images/icBicycle'
import { IcRun } from './images/IcRun'
import { IcSwimming } from './images/IcSwimming'
import { IcSki } from './images/IcSki'
import { ActivityType, CurrentActivityType } from '../../models/commonModels'
import { setActivityType } from '../../store/app-slice/AppSlice'
import { IcWalk } from './images/icWalk'
export const ActivityBar = () =>{
const dispatch:any= useAppDispatch()
const currentActivity = useAppSelector(state=>state.appStore.activity_type)
const colorGreen:string = "#50964E"
const colorGray:string = "#CCCCCC"
const colorYellow:string = "#F75D24"

useEffect(()=>{
    var currentActivityType = localStorage.getItem("currentActivityType")
    var CT:CurrentActivityType = {activityType:ActivityType.RUN}
    if(currentActivityType==null){
        setActivity(CT.activityType)
    }else{
        CT.activityType=JSON.parse(currentActivityType)
    }
    if(currentActivity?.toString()!=CT.activityType.toString()){
        dispatch(setActivityType(CT.activityType))
    }
},[currentActivity])

const setActivity = (type:ActivityType) =>{
    dispatch(setActivityType(type))
    localStorage.setItem("currentActivityType",JSON.stringify(type))
}
    return(
        <div style={{overflow:"scroll", maxWidth:"90vw"}}>
            <div className={styles.activityBarContainer}>
            <div onClick={()=>setActivity(ActivityType.RUN)} className={styles.activityBarItem}>
                {currentActivity==ActivityType.RUN.toString()&&<div className={styles.activityBarLine}/>}
                <IcRun color={currentActivity==ActivityType.RUN.toString()?colorGreen:colorGray}/>
            </div>
            <div onClick={()=>setActivity(ActivityType.BICYCLE)} className={styles.activityBarItem}>
                 {currentActivity==ActivityType.BICYCLE.toString()&&<div className={styles.activityBarLine}/>}
                <IcBicycle color={currentActivity==ActivityType.BICYCLE?colorGreen:colorGray}/>
            </div>
            <div onClick={()=>setActivity(ActivityType.SWIMMING)} className={styles.activityBarItem}>
                 {currentActivity==ActivityType.SWIMMING.toString()&&<div className={styles.activityBarLine}/>}
                <IcSwimming color={currentActivity==ActivityType.SWIMMING?colorGreen:colorGray}/>
            </div>
            <div onClick={()=>setActivity(ActivityType.SKIS)} className={styles.activityBarItem}>
                 {currentActivity==ActivityType.SKIS.toString()&&<div className={styles.activityBarLine}/>}
               <IcSki color={currentActivity==ActivityType.SKIS?colorGreen:colorGray}/>
            </div>
            <div onClick={()=>setActivity(ActivityType.WALK)} className={styles.activityBarItem}>
                 {currentActivity==ActivityType.WALK.toString()&&<div className={styles.activityBarLine}/>}
               <IcWalk color={currentActivity==ActivityType.WALK?colorGreen:colorGray}/>
            </div>
            
        </div>
        </div>
        
    )
}